import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Mail, Phone, MapPin } from "lucide-react";
import logo from "/lovable-uploads/5639bd1d-d899-4190-af54-f5f73944d997.png";

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo e Descrição */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img src={logo} alt="Arena Pro Player Logo" className="h-12 w-auto" />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              A plataforma líder em mentorias para gamers profissionais. 
              Conectamos jogadores com mentores experientes para acelerar 
              seu crescimento no mundo dos esports.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/arena.proplayer" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://www.tiktok.com/@arena.pro.player" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label="TikTok"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
              <a 
                href="https://youtube.com/@arenaproplayer" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label="YouTube"
              >
                <Youtube size={20} />
              </a>
            </div>
          </div>

          {/* Links Rápidos */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/" 
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Início
                </Link>
              </li>
              <li>
                <Link 
                  to="/mentores" 
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Mentores
                </Link>
              </li>
              <li>
                <Link 
                  to="/jogos" 
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Jogos
                </Link>
              </li>
              <li>
                <Link 
                  to="/mentorias" 
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Mentorias
                </Link>
              </li>
              <li>
                <Link 
                  to="/como-funciona" 
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Como Funciona
                </Link>
              </li>
            </ul>
          </div>

          {/* Para Mentores */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Para Mentores</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/cadastro" 
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Torne-se Mentor
                </Link>
              </li>
              <li>
                <Link 
                  to="/painel-mentor" 
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Painel do Mentor
                </Link>
              </li>
              <li>
                <Link 
                  to="/guia-do-mentor" 
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Guia do Mentor
                </Link>
              </li>
              <li>
                <Link 
                  to="/politicas-pagamento" 
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                >
                  Políticas de Pagamento
                </Link>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contato</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Mail size={16} className="text-gray-400" />
                <span className="text-gray-300 text-sm">contato@arenaproplayer.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone size={16} className="text-gray-400" />
                <span className="text-gray-300 text-sm">(11) 94300-6646</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin size={16} className="text-gray-400" />
                <span className="text-gray-300 text-sm">São Paulo, SP - Brasil</span>
              </div>
            </div>
            <div className="pt-2">
              <h4 className="text-sm font-medium mb-2">Suporte</h4>
              <div className="space-y-1">
                <a 
                  href="https://wa.me/5511943006646?text=Ol%C3%A1%2C%20vim%20atrav%C3%A9s%20do%20site%20Arena%20Pro%20Player%20e%20gostaria%20de%20ajuda."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm block"
                >
                  Central de Ajuda
                </a>
                <a 
                  href="https://wa.me/5511943006646?text=Ol%C3%A1%2C%20tenho%20algumas%20d%C3%BAvidas%20sobre%20a%20Arena%20Pro%20Player."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors duration-200 text-sm block"
                >
                  FAQ
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Linha divisória */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © 2024 Arena Pro Player. Todos os direitos reservados.
            </div>
            <div className="flex flex-wrap justify-center md:justify-end gap-4 md:gap-6">
              <Link 
                to="/termos-de-uso"
                className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
              >
                Termos de Uso
              </Link>
              <Link 
                to="/politica-privacidade"
                className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
              >
                Política de Privacidade
              </Link>
              <button 
                onClick={() => {
                  // Remove o consentimento de cookies para mostrar o modal novamente
                  localStorage.removeItem('cookieConsent');
                  window.location.reload();
                }}
                className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
              >
                Configurar Cookies
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 